import React from 'react';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';

// InfoBlocks
import {
  InfoSection,
  InstallGallery,
  FeatureList,
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';

const POP = () => {
  const installColumns = [
    {
      label: '주간',
      images: [
        '/images/products/facilities/POP4.jpg',
        '/images/products/facilities/POP5.jpg',
      ],
    },
    {
      label: '야간',
      images: [
        '/images/products/facilities/POP3.jpg',
        '/images/products/facilities/POP2.jpg',
      ],
    },
  ];

  const features = [
    {
      title: '안전 중심의 설계',
      bullets: [
      {
        label: (
          <>고속 주행 차량과 순찰차 간 충돌 위험을 최소화하기 위한 방호 구조 적용</>
        ),
      },
      {
        label: (
          <>촬영·관측·단속 장비 설치를 고려한 최적의 배치 및 시야 확보</>
        ),
      },
      {
        label: (
          <>야간·악천후 환경에서도 안전 확보가 가능한 반사도·표지 체계 도입</>
        ),
      },
      ]
    },
    {
      title: '효율적인 교통 단속 및 사고 대응 지원',
      bullets: [
      {
        label: (
          <>순찰차의 신속한 진입·대기를 위한 최적 동선 설계</>
        ),
      },
      {
        label: (
          <>사고 발생 시 즉각적인 초동 대응을 위한 공간 여유 확보</>
        ),
      },
      {
        label: (
          <>단속 장비 및 교통 지휘 장비 설치가 용이한 구조</>
        ),
      },
      ]
    },
    {
      title: '설치 환경에 따른 맞춤형 구성',
      bullets: [
      {
        label: (
          <>고속국도 노선 특성, 지형, 교통량 등을 반영한 현장 맞춤형 설계</>
        ),
      },
      {
        label: (
          <>다양한 가드레일 및 도로 구조와의 호환성 제공</>
        ),
      },
      {
        label: (
          <>필요 기능(조명·전원·CCTV·통신 등)에 따라 확장 가능한 모듈형 구조</>
        ),
      },
      ]
    },
    {
      title: '유지관리 편의성 강화',
      bullets: [
      {
        label: (
          <>장기간 사용을 고려한 내구성 높은 소재 적용</>
        ),
      },
      {
        label: (
          <>유지보수 작업자의 접근성 및 안전성을 고려한 구조 설계</>
        ),
      },
      {
        label: (
          <>주변 시설과의 간섭을 최소화한 간편한 시공 방식</>
        ),
      },
      ]
    },
  ];

  

  return (
    <>
      <HeroSection
        title={`경찰 순찰차 주차시설`}
        subtitle={`경찰 교통안전업무의 효율성을 증진시킵니다`}
        backgroundImage="/images/products/facilities/POP4.jpg"
        breadcrumbs={[
          { label: '홈', path: '/' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '경찰 순찰차 주차시설' },
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`효율적인 교통안전업무를 위해`}
        title={`경찰 순찰차 주차시설`}
        description={
          <>
            고속국도에서 경찰청이 수행하는 교통안전 지도·단속·사고 처리 등이 안전하고 효율적으로 이루어질 수 있도록 마련된 전용 시설입니다.
            <br />
            <br />
            본 시설은 고속국도 이용차량의 원활한 교통 관리와 긴급 대응을 위해 {' '}
            순찰차가 안전하게 주차하고 주변 상황을 감시·대기할 수 있는 공간을 확보하는 데 목적을 두고 있습니다.

          </>
        }
        images={[
          '/images/products/facilities/POP4.jpg',
          '/images/products/facilities/POP5.jpg',

        ]}
      />

      <SectionDivider />

      <InfoSection title="설치 사진">
        <InstallGallery columns={installColumns} />
      </InfoSection>


      <InfoSection title="제품 특징">
        <FeatureList features={features} />
      </InfoSection>

      <ProductDetailNav
        category="facilities"
        currentPath="/products/facilities/POP"
        listPath="/products/facilities"
      />


      <CTASection />
    </>
  );
};

export default POP;
